import { useEffect, useState } from 'react';
import { postDataWithToken } from 'Utils/api';

const routesUrl = (tripId) => `/api/0.1/tracking/trip/${tripId}/routes`;

/**
 * Fetches the candidate routes (one polyline per data source - google,
 * custom, historical, return) for a trip.
 */
export const useRoutes = (tripId) => {
  const [routes, setRoutes] = useState([]);

  useEffect(() => {
    if (!tripId) return;
    postDataWithToken(routesUrl(tripId), {})
      .then((response) => {
        const data = (response && response.data) || {};
        console.log('[TripTrackingV2] routes stored:', data.routes);
        setRoutes(data.routes || []);
      })
      .catch((error) => console.log('[TripTrackingV2] routes error:', error));
  }, [tripId]);

  return routes;
};
